import * as Sentry from '@sentry/react'

const HEADER = 'x-request-id'
const apiBase = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '')

// Solo agregamos el header a llamadas del propio API (relativas al proxy o al VITE_API_URL),
// no a terceros (CDP, RPC, etc.).
function isApiRequest(url: string): boolean {
  return /^\/(api|projects|uploads)\b/.test(url) || (apiBase !== '' && url.startsWith(apiBase))
}

function urlOf(input: RequestInfo | URL): string {
  if (typeof input === 'string') return input
  if (input instanceof URL) return input.toString()
  return input.url
}

/**
 * Parchea `window.fetch` una sola vez: en cada request al API genera (o respeta) un
 * `x-request-id` y lo registra como tag `request_id` en Sentry. Ese mismo id lo reciben
 * NestJS y Phoenix, de modo que un error se correlaciona en los 3 servicios.
 */
export function installRequestIdFetch(): void {
  if (typeof window === 'undefined') return
  const original = window.fetch
  if ((original as { __ridPatched?: boolean }).__ridPatched) return

  const patched: typeof window.fetch = (input, init) => {
    if (!isApiRequest(urlOf(input))) return original(input, init)

    const headers = new Headers(
      init?.headers ?? (input instanceof Request ? input.headers : undefined),
    )
    if (!headers.has(HEADER)) headers.set(HEADER, crypto.randomUUID())
    Sentry.getCurrentScope().setTag('request_id', headers.get(HEADER))

    return original(input, { ...init, headers })
  }

  ;(patched as { __ridPatched?: boolean }).__ridPatched = true
  window.fetch = patched
}
